import { render, staticRenderFns } from "./genset.vue?vue&type=template&id=0a6cc023&"
import script from "./genset.vue?vue&type=script&lang=js&"
export * from "./genset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports